import React from 'react';
import styles from './style/grid_style.module.scss';
import PropTypes from 'prop-types'
import Foundation, { FOUNDATION_PROPTYPES } from '../Foundation'

const Grid = ({ typeface, wide, areas, display, children, style  = {}, className = '', ...props }) => {
    
    
    const _children = () => { 
        if (areas) {
            return children.map((child, i) => {
                const areaIndex = i % areas.length;
                return React.cloneElement(child, { style: { ...child.style, gridArea: areas[areaIndex] } })
            })
        } else {
            return children;
        }        
    }
    
    return (
        <Foundation {...props}>
            <div className={`${className ? (className + ' ') : ''} ${wide && styles.wide} ${styles.grid}`} style={style}>
                {_children()}
            </div>
        </Foundation>
    );
};

Grid.propTypes = {
    ...FOUNDATION_PROPTYPES,
    areas: PropTypes.array,
    className: PropTypes.string,
    style: PropTypes.object,
    wide: PropTypes.bool,
};

// Typography.defaultProps = {
//     display: '',
// }

export default Grid;
